import React from "react";
import { Card, Form } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";

const MobileMatrixMultiOptionQuestion = ({
  question,
  formValues,
  handleSelectChange,
  showError
}) => {
  const hasAnswer = formValues[question.tempId]?.some(answer =>
    Object.values(answer).some(rowValues =>
      rowValues.some(value => value !== "")
    )
  );

  return (
    <Card
      className={`mt-3 ${
        question.isMandatory && showError && !hasAnswer ? "border-danger" : ""
      }`}
    >
      <Card.Body>
        <Form.Group>
          <div className="d-flex flex-column">
            <Form.Label>
              <b style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {question.tempId}.{question.questionText}
                {question.isMandatory && (
                  <span className="text-danger">*</span>
                )}
              </b>
            </Form.Label>
            <Form.Label>
              <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
            </Form.Label>
            {question.isMandatory && showError && !hasAnswer && (
              <ErrorComponent message={question.requiredErrorText} />
            )}
          </div>

          <div className="row">
            {question.rows.map((row, rowIndex) => (
              <div key={rowIndex} className="col-12 col-md-6">
                <div className="border p-3 mb-3">
                  <h5>{row}</h5>
                  {question.columns.map((col, colIndex) => (
                    <div key={colIndex} className="mb-2">
                      <Form.Label>{col}</Form.Label>
                      <Form.Select
                        id={`${question.tempId}_${rowIndex}_${colIndex}`}
                        value={
                          formValues[question.tempId]
                            ?.find(a => a[`${question.tempId}_r${rowIndex + 1}`])
                            ?.[`${question.tempId}_r${rowIndex + 1}`]?.[colIndex] || ""
                        }
                        onChange={(e) =>
                          handleSelectChange(e, rowIndex, colIndex)
                        }
                      >
                        <option value="">Select</option>
                        {question.cellOptions.map((option, i) => (
                          <option key={i} value={option}>
                            {option}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default MobileMatrixMultiOptionQuestion;
